export const Colors = {
  WHITE: '#ffffff',
  PINK: '#a61460',
}
